/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSupportingExaminationPreviewDto
 */
export interface GetSupportingExaminationPreviewDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSupportingExaminationPreviewDto
     */
    synevoNames?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSupportingExaminationPreviewDto
     */
    synevoIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSupportingExaminationPreviewDto
     */
    otherNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSupportingExaminationPreviewDto
     */
    articleWithAutoSupport: boolean;
}

/**
 * Check if a given object implements the GetSupportingExaminationPreviewDto interface.
 */
export function instanceOfGetSupportingExaminationPreviewDto(value: object): value is GetSupportingExaminationPreviewDto {
    if (!('articleWithAutoSupport' in value) || value['articleWithAutoSupport'] === undefined) return false;
    return true;
}

export function GetSupportingExaminationPreviewDtoFromJSON(json: any): GetSupportingExaminationPreviewDto {
    return GetSupportingExaminationPreviewDtoFromJSONTyped(json, false);
}

export function GetSupportingExaminationPreviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSupportingExaminationPreviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'synevoNames': json['synevoNames'] == null ? undefined : json['synevoNames'],
        'synevoIds': json['synevoIds'] == null ? undefined : json['synevoIds'],
        'otherNames': json['otherNames'] == null ? undefined : json['otherNames'],
        'articleWithAutoSupport': json['articleWithAutoSupport'],
    };
}

export function GetSupportingExaminationPreviewDtoToJSON(value?: GetSupportingExaminationPreviewDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'synevoNames': value['synevoNames'],
        'synevoIds': value['synevoIds'],
        'otherNames': value['otherNames'],
        'articleWithAutoSupport': value['articleWithAutoSupport'],
    };
}

